require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-code-fellows-is-coming-to-a-city-near-you.json") })
        }
      }, "path---blog-code-fellows-is-coming-to-a-city-near-you");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-code-fellows-is-coming-to-a-city-near-you!./.cache/json/blog-code-fellows-is-coming-to-a-city-near-you.json
// module id = 763
// module chunks = 231608221292675